<!-- eslint-disable vuejs-accessibility/label-has-for -->
<template>
  <div class="base-radio">
    <div
      class="base-radio--list"
      :class="{ [`base-radio--${direction}`]: direction }"
    >
      <div
        v-for="radio in items"
        :key="radio.value"
        class="base-radio--item"
      >
        <input
          :id="radio.name || radio.value"
          type="radio"
          :name="radio.name || 'base-radio'"
          :value="radio.value"
          :checked="value === radio.value"
          :disabled="disabled"
          @change="$emit('input', radio.value)"
        >
        <label
          :for="radio.name || radio.value"
          v-html="radio.label"
        />
      </div>
    </div>
    <div
      v-if="error"
      class="base-radio--error"
      role="alert"
    >
      <span>{{ error }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseRadio',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Boolean],
      default: '',
    },
    direction: {
      type: String,
      default: 'row',
      validator: (value) => ['row', 'column'].includes(value),
    },
    gap: {
      type: String,
      default: '1.875rem',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.base-radio {
  &--list {
    display: flex;
    flex-direction: v-bind(direction);
    flex-wrap: wrap;
  }

  &--column {
    gap: 0.5rem;
  }

  &--error {
    display: block;
    font-size: 12px;
    color: var(--bs-danger);
    line-height: 1.25;
    padding-top: .5rem;
  }

  &--row {
    gap: v-bind(gap);
  }

  &--item {
    display: flex;
    align-items: center;
    gap: 0.625rem;

    input {
      all: unset;
      display: inline-block;
      height: 1.25rem;
      width: 1.25rem;
      border-radius: 99px;
      border: 1px solid #D9D9D9;
      background-color: #FFFFFF;

      &:checked::before {
        content: '';
        display: block;
        height: 1rem;
        width: 1rem;
        margin: 0.125rem;
        border-radius: 99px;
        background-color: var(--company-main-primary);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    label {
      cursor: pointer;
    }

    input:disabled + label {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
